import script from "./PriceList.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceList.vue?vue&type=script&setup=true&lang=js"

import "./PriceList.vue?vue&type=style&index=0&id=339e968b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-339e968b"]])

export default __exports__